<template>
  <div class="el-uploader">
    <input
        class="upload-input"
        ref="upload"
        type="file"
        multiple
        :accept="accept"
        @change="handleChange"
    />
    <el-button icon="el-icon-plus" @click="$refs.upload.click()">
      Choose File
    </el-button>
    <div class="upload-progress">
      <el-progress
          v-if="showProgress"
          :percentage="percentage"
          :status="status"
          :show-text="false"
          :stroke-width="3"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "file-upload",
  props: {
    action: {
      type: String,
      required: true,
    },
    accept: String,
    headers: Object,
    file: Object,
    message: String,
  },
  data() {
    return {
      selectFiles: [],
      showProgress: false,
      percentage: 0,
      status: "success",
    };
  },
  methods: {
    reset() {
      this.showProgress = false;
      this.percentage = 0;
      this.status = "success";
    },
    handleChange(e) {
      const files = Array.prototype.slice.call(e.target.files);
      this.$refs.upload.value = "";
      let isNotAccept = false;
      if (this.accept) {
        const accept = this.accept.replace(/\./g, "").replace(/,/g, "|");
        const acceptReg = new RegExp(`.(?:${accept})$`, "i");
        isNotAccept = files.some(file => {
          return !acceptReg.test(file.name);
        });
      }
      if (isNotAccept) {
        this.$message.warning(this.message);
        return;
      }
      this.showProgress = false;
      this.percentage = 0;
      this.status = "success";
      this.selectFiles = files;
      if (this.selectFiles.length > 0) {
        let formData = new FormData();
        files.forEach(file => {
          formData.append("file", file);
        });
        this.axios.post(this.action, formData, {
          headers: {"Content-Type": "multipart/form-data", ...this.headers},
          onUploadProgress: (e) => {
            if (e.lengthComputable) {
              this.showProgress = true;
              this.percentage = ((e.loaded / e.total) * 100) | 0;
            }
          },
        }).then(({code, data}) => {
          if (code === 200) {
            this.$message.success("Upload file successfully");
            this.reset();
            this.$emit("success", data);
          } else {
            this.$message.success("Upload file failure");
            this.status = "exception";
            this.$emit("fail", files);
          }
        }).catch(() => {
          this.status = "exception";
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.el-uploader {
  display: inline-flex;
  position: relative;

  .upload-input {
    position: absolute;
    width: 0;
    height: 0;
    opacity: 0;
    cursor: pointer;
    -webkit-appearance: none;
    display: none;
  }

  .upload-progress {
    position: absolute;
    width: 100%;
    bottom: -10px;
    height: 6px;
  }
}
</style>
